import { observer } from 'mobx-react-lite'

import { useRootStore } from 'stores/RootStore'
import { absurd } from 'types'

import { BaseContextMenu } from './BaseContextMenu'
import { BasePopoverMenu } from './BasePopoverMenu'
import { BaseMenuProps, MenuType } from './Types'

export const BaseMenu = observer((props: BaseMenuProps) => {
  const isSidebarHovered = useRootStore().leftSidebarStore.isHovering()
  if (!isSidebarHovered && props.visible) props.setVisible(false)

  switch (props.type) {
    case MenuType.popover:
      return <BasePopoverMenu {...props} />
    case MenuType.contextMenu:
      return <BaseContextMenu {...props} />
    default:
      absurd(props)
      return null
  }
})
